// import Axios from "axios";
const BASEURL = "http://ajoo.app.wavepalmapps.com";

// export var postData = (route, data) => {
//   return new Promise((resolve, reject) => {
//     Axios.post(baseUrl + route, data)
//       .then((response) => {
//         resolve(response.data);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });
// };

// export const getData = (route, data) => {
//   return new Promise((resolve, reject) => {
//     fetch(baseUrl + route, {
//       method: "GET",
//       headers: {},
//       body: JSON.stringify(data),
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         resolve(data);
//       })
//       .catch((error) => {
//         console.error("error in post api", error);
//         reject(error);
//       });
//   });
// };

export const sendEmail = (URL, data) => {
  return new Promise((resolve, reject) => {
    fetch(BASEURL + URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
  });
};
